import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import moment from 'moment'

import Icon from 'components/_new/ui/Icon/Icon'
import Message from 'components/text/Message/Message'

import s from './DeliveryStatus.scss'
import messages from './messages'


const getDeliveryDateMessage = ({ deliveryDate, monthOnly }) => {
  let month
  let year

  if (typeof deliveryDate === 'object') {
    if (deliveryDate.year) {
      month = moment.monthsShort()[deliveryDate.month - 1] // Jan
      year  = deliveryDate.year // eslint-disable-line
    }
    else {
      month = moment.months()[deliveryDate.month - 1] // January
    }
  }
  else if (deliveryDate) {
    month = moment(deliveryDate).format(monthOnly ? 'MMMM' : 'MMM')

    if (!monthOnly) {
      year = moment(deliveryDate).format('YYYY')
    }
  }

  return `${month}${year ? ` ${year}` : ''}`
}

const DeliveryStatus = ({ className, color, status, deliveryDate, monthOnly, textOnly }) => {
  if (deliveryDate) {
    status = 'arrivesIn'
  }

  const deliveryDateMessage = deliveryDate ? getDeliveryDateMessage({ deliveryDate, monthOnly }) : ''
  const textClassName       = cx(s.text, s[`${color}Color`])

  if (textOnly) {
    return (
      <div className={cx(textClassName, className)}>
        <Message text={messages[status]} /> {deliveryDateMessage ? <b>{deliveryDateMessage}</b> : ''}
      </div>
    )
  }

  return (
    <div className={cx(s.deliveryStatus, className)}>
      <Icon className={s.truckIcon} name="truck" color={color} />
      <span className={textClassName}>
        <Message text={messages[status]} /> {deliveryDateMessage ? <b>{deliveryDateMessage}</b> : ''}
      </span>
    </div>
  )
}

DeliveryStatus.propTypes = {
  className: PropTypes.string,
  status: PropTypes.oneOf([ 'processing', 'onTheWay', 'arrivesIn', 'delivered' ]), // TODO set statuses from backend
  color: PropTypes.oneOf([ 'brand', 'gray' ]),
  deliveryDate: PropTypes.oneOfType([
    PropTypes.shape({
      month: PropTypes.number,
      year: PropTypes.number,
    }),
    PropTypes.number, // milliseconds - 1553450651862
    PropTypes.string, // ISO string - 2019-12-24T18:05:48.123Z
  ]),
  monthOnly: PropTypes.bool, // if deliveryDate of type number or string passed and we want only month to be visible
  textOnly: PropTypes.bool,
}

DeliveryStatus.defaultProps = {
  color: 'brand',
}


export default DeliveryStatus
